import moment from 'moment';

export const TYPE_ACTIVITE = [
  "Atelier",
  "Meeting"
];

export const TYPE_BUSINESS = [
  "Achat",
  "Vente"
];

export const TRIMESTRES = [
  "Trimestre 1",
  "Trimestre 2",
  "Trimestre 3",
  "Trimestre 4"
]

export const TYPE_MISSION = [
  "Dépense",
  "Entrée"
];

export const CATEGORIE_MISSION = [
  "Restaurant",
  "Dadupa",
  "Startup Houdane",
  "Bailleur de fonds Ab"
];

export const TYPE_BIEN = [
  "Produit",
  "Service"
];

export const COLUMNS_ACTIVITE = [
  {
    name: "Date",
    // selector: row => new Date(row.date).toLocaleDateString(),
    selector: row => moment(new Date(row.date)).format("DD.MM.YYYY"),
    sortable: true
  },
  {
    name: "Nom de l'activité",
    selector: "nom",
    sortable: true
  },
  {
    name: "Type",
    selector: "type",
    sortable: true
  },
  {
    name: "Note",
    selector: "note",
    sortable: true
  },
  {
    name: "Tag Membres présents + NB",
    selector: "users",
    sortable: true
  },
  {
    name: "Statut",
    selector: "statut",
    sortable: true
  }
]

export const MULTI_SELECT_STYLE = {
  chips: {
    background: '#6A0CAC'
  },
  multiselectContainer: {
    highlightOption: {
      background: '#6A0CAC'
    },
    optionListContainer: {
      position: 'relative'
    }
  },
  searchBox: {
    border: 'none',
    padding: '10px'
  }
}

export const ACTIVITE_STATUS = {
  DONE: 'Effectué',
  PROGRESS: 'En cours',
  NOT_DONE: 'Non Effectué'
}

export const ACTIVITE_STATUS_COLOR = {
  DONE: '#0c6316',
  PROGRESS: '#6A0CAC',
  NOT_DONE: '#EF5350'
}

// Montant d'une ligne d'opérations "Business" (montant HT après remise, puis TVA).
// Formule de référence unique, utilisée par Ma Startup (Business.js) et le Dashboard Startup.
export function computeOperationsMontant(operations) {
  if (!operations) return 0;
  let montant = 0;
  operations.forEach((el) => {
    const montantHorsTaxe = Number(el?.montant || 0) * (1 - Number(el?.remise || 0) / 100);
    montant += montantHorsTaxe * (1 + Number(el?.tva || 0) / 100);
  });
  return montant;
}

// Calcule les totaux Achats/Ventes à partir des opérations "Business".
export function computeAchatVenteTotals(data) {
  let achat = 0;
  let vente = 0;
  (data || []).forEach((item) => {
    const montant = computeOperationsMontant(item?.operations);
    const type = item?.type?.toLowerCase();
    if (type === "achat") achat += montant;
    else if (type === "vente") vente += montant;
  });
  return { achat, vente };
}
